var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCommercialServices = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 3a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8h-2V3H3v14h10v2H3a2 2 0 0 1-2-2V3Zm15 10v11l3.429-3.3H24L16 13Zm-9-2H5V9h2v2Zm0 4H5v-2h2v2Zm0-8H5V5h2v2Zm8 4H9V9h6v2Zm-2 4H9v-2h4v2ZM9 7V5h6v2H9Z",
  fill: "#000",
  fillOpacity: 0.54
})));
export default SvgCommercialServices;